export const craft = [
  {
    category: "Systems",
    items: [
      { skill: "Component Arch", color: "#000000" },
      { skill: "Design Tokens", color: "#ff0000" },
      { skill: "Accessibility", color: "#38bdf8" },
      { skill: "Performance", color: "#88ce02" },
      { skill: "Responsive", color: "#007acc" },
      { skill: "Cross-browser", color: "#e05a33" },
    ]
  },
  {
    category: "Process",
    items: [
      { skill: "Prototyping", color: "#ff008c" },
      { skill: "Iteration", color: "#5a67d8" },
      { skill: "Code Review", color: "#000000" },
      { skill: "Documentation", color: "#38bdf8" },
      { skill: "Collaboration", color: "#88ce02" },
      { skill: "Mentorship", color: "#007acc" },
    ]
  },
  {
    category: "Mindset",
    items: [
      { skill: "Attention to Detail", color: "#ff0000" },
      { skill: "User-Centric", color: "#0364d4" },
      { skill: "Problem Solving", color: "#e05a33" },
      { skill: "Craft & Polish", color: "#000000" },
      { skill: "Adaptability", color: "#38bdf8" },
      { skill: "Curiosity", color: "#88ce02" },
    ]
  },
];

